/**
 * 路由令牌配置
 */
export default class RouterIdentityConfig {

  /**
   * 通用路由权限
   */
  static common: string = 'common';

  /**
   * 研报工厂
   */
  static factory: string = 'WeeklyReport';

  /**
   * 机构-我要编辑
   */
  static organizationEdit: string = 'Organization.Edit';

  /**
   * 机构-专家认证
   */
  static organizationExpertCertification = 'Organization.ExpertCertification';

  /**
   * 融资-后台信息
   */
  static financeBG = 'CNABS.Financing.ABSFinancing.FinancingBG';

  /**
   * 融资-文件上传
   */
  static financeUpload = 'CNABS.Financing.ABSFinancing.FinancingUpload';

  /**
   * CNABS-后台管理
   */
  static cnabsManage = 'PersonCenter.Manage';
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/abs/config/routerIdentityConfig.ts